module.exports = __webpack_public_path__ + "static/media/giftcard-gray.f2ee30a4.svg";